var _dec, _dec2, _class, _descriptor, _descriptor2, _dec3, _class2, _descriptor3;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import ModelTraits from "../ModelTraits";
import primitiveTrait from "../Decorators/primitiveTrait";
import objectTrait from "../Decorators/objectTrait";
export let EditorTraits = (_dec = primitiveTrait({
  type: "boolean",
  name: "Is editable?",
  description: "Indicates whether we can edit some aspect of the model item like its visibility or color"
}), _dec2 = primitiveTrait({
  type: "boolean",
  name: "Is transformable?",
  description: "Indicates whether we can rotate/translate/scale the model"
}), _class = class EditorTraits extends ModelTraits {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "isEditable", _descriptor, this);
    _initializerDefineProperty(this, "isTransformable", _descriptor2, this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "isEditable", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "isTransformable", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _class);

/**
 * Traits for an external tool
 */
let PlaceEditorTraits = (_dec3 = objectTrait({
  type: EditorTraits,
  name: "Editor traits",
  description: "Editor traits"
}), _class2 = class PlaceEditorTraits extends ModelTraits {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "editing", _descriptor3, this);
  }
}, _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "editing", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class2);
export { PlaceEditorTraits as default };